import { Box } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

export default createWebRegistration({
  components: {
    '@reflex/plugin-seeds/web/BlueprintPreview': () =>
      import('./BlueprintPreview').then((m) => ({ default: m.BlueprintPreview })),
  },
  icons: { Box },
});
